module.exports = __webpack_public_path__ + "static/media/logo-bw.c496021b.svg";